import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { type MiddlewhereFilter } from 'app/main/components/filter/FilterItemManager';
import { type FiltersType } from 'app/main/components/hooks/useFilters';
import { Form, useSettings, Utils } from 'app/main/components';
import Filter from 'app/main/components/filter/Filter';
import FilterSaveDialog from 'app/main/components/filter/filter-saved/FilterSaveDialog';
import FilterLoadDialog from 'app/main/components/filter/filter-saved/FilterLoadDialog';

interface AddRowsFilterDialogProps {
	title: string;
	module: string;
	defaultFilters: MiddlewhereFilter[];
	currentFilters: FiltersType['currentFilters'];
	setCurrentFilters: FiltersType['setCurrentFilters'];
	handleFilterChange: FiltersType['handleFilterChange'];
	showResults: () => void;
	closeDialog: () => void;
}

export default function AddRowsFilterDialog(props: AddRowsFilterDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const [formId] = React.useState(uuidv4());
	const [isOpenSaveDialog, setIsOpenSaveDialog] = React.useState(false);
	const [isOpenLoadDialog, setIsOpenLoadDialog] = React.useState(false);

	function handleClear() {
		props.setCurrentFilters([]);
	}

	function handleFilterSave() {
		if (props.currentFilters.length === 0)
			dispatch(Utils.alertLocalizedMsg(t, 'ERROR_FILTER_SAVE_EMPTY', 'warning'));
		else setIsOpenSaveDialog(true);
	}

	function handleFilterLoad() {
		setIsOpenLoadDialog(true);
	}

	return (
		<>
			<DialogTitle>{props.title}</DialogTitle>
			<DialogContent>
				<Form id={formId} onSubmit={props.showResults}>
					<Filter
						module={props.module}
						defaultFilters={props.defaultFilters}
						currentFilters={props.currentFilters}
						handleFilterChange={props.handleFilterChange}
					/>
				</Form>
			</DialogContent>
			<DialogActions>
				<Button onClick={props.closeDialog}>{t('DIALOG_ACTION_CANCEL')}</Button>
				{/* <Button onClick={handleFilterSave}>{t('DIALOG_ACTION_SAVE_FILTER')}</Button>
				<Button onClick={handleFilterLoad}>{t('DIALOG_ACTION_LOAD_FILTER')}</Button> */}
				<Button onClick={handleClear}>{t('DIALOG_ACTION_CLEAR')}</Button>
				<Button type="submit" form={formId} color="secondary">
					{t('DIALOG_ACTION_ADD')}
				</Button>
			</DialogActions>
			{/* SAVE FILTER DIALOG */}
			<FilterSaveDialog
				module={props.module}
				isOpen={isOpenSaveDialog}
				closeDialog={() => setIsOpenSaveDialog(false)}
				currentFilters={props.currentFilters}
			/>
			{/* LOAD FILTER DIALOG */}
			<FilterLoadDialog
				module={props.module}
				isOpen={isOpenLoadDialog}
				closeDialog={() => setIsOpenLoadDialog(false)}
				setCurrentFilters={props.setCurrentFilters}
			/>
		</>
	);
}
